'use strict';

var map = {
  'address.buildingNumber': '{{$location.buildingNumber}}',
  'address.cardinalDirection': '{{$location.cardinalDirection}}',
  'address.city': '{{$location.city}}',
  'address.cityName': '{{$location.city}}',
  'address.country': '{{$location.country}}',
  'address.countryCode': '{{$location.countryCode}}',
  'address.county': '{{$location.county}}',
  'address.direction': '{{$location.direction}}',
  'address.latitude': '{{$location.latitude}}',
  'address.longitude': '{{$location.longitude}}',
  'address.nearbyGPSCoordinate': '{{$location.nearbyGPSCoordinate}}',
  'address.ordinalDirection': '{{$location.ordinalDirection}}',
  'address.secondaryAddress': '{{$location.secondaryAddress}}',
  'address.state': '{{$location.state}}',
  'address.stateAbbr': '{{$location.state(abbreviated=true)}}',
  'address.street': '{{$location.street}}',
  'address.streetAddress': '{{$location.streetAddress}}',
  'address.streetName': '{{$location.street}}',
  'address.timeZone': '{{$location.timeZone}}',
  'address.zipCode': '{{$location.zipCode}}',
  'animal.bear': '{{$animal.bear}}',
  'animal.bird': '{{$animal.bird}}',
  'animal.cat': '{{$animal.cat}}',
  'animal.cetacean': '{{$animal.cetacean}}',
  'animal.cow': '{{$animal.cow}}',
  'animal.crocodilia': '{{$animal.crocodilia}}',
  'animal.dog': '{{$animal.dog}}',
  'animal.fish': '{{$animal.fish}}',
  'animal.horse': '{{$animal.horse}}',
  'animal.insect': '{{$animal.insect}}',
  'animal.lion': '{{$animal.lion}}',
  'animal.rabbit': '{{$animal.rabbit}}',
  'animal.rodent': '{{$animal.rodent}}',
  'animal.snake': '{{$animal.snake}}',
  'animal.Type': '{{$animal.type}}',
  'color.cmyk': '{{$color.cmyk}}',
  'color.colorByCSSColorSpace': '{{$color.colorByCSSColorSpace}}',
  'color.cssSupportedFunction': '{{$color.cssSupportedFunction}}',
  'color.cssSupportedSpace': '{{$color.cssSupportedSpace}}',
  'color.hsl': '{{$color.hsl}}',
  'color.human': '{{$color.human}}',
  'color.hwb': '{{$color.hwb}}',
  'color.lab': '{{$color.lab}}',
  'color.lch': '{{$color.lch}}',
  'color.rgb': '{{$color.rgb}}',
  'color.space': '{{$color.space}}',
  'commerce.color': '{{$color.human}}',
  'commerce.department': '{{$commerce.department}}',
  'commerce.price': '{{$commerce.price}}',
  'commerce.product': '{{$commerce.product}}',
  'commerce.productAdjective': '{{$commerce.productAdjective}}',
  'commerce.productDescription': '{{$commerce.productDescription}}',
  'commerce.productMaterial': '{{$commerce.productMaterial}}',
  'commerce.productName': '{{$commerce.productName}}',
  'company.bs': '{{$company.buzzPhrase}}',
  'company.bsAdjective': '{{$company.buzzAdjective}}',
  'company.bsBuzz': '{{$company.buzzVerb}}',
  'company.bsNoun': '{{$company.buzzNoun}}',
  'company.catchPhrase': '{{$company.catchPhrase}}',
  'company.catchPhraseAdjective': '{{$company.catchPhraseAdjective}}',
  'company.catchPhraseDescriptor': '{{$company.catchPhraseDescriptor}}',
  'company.catchPhraseNoun': '{{$company.catchPhraseNoun}}',
  'company.companySuffix': '{{$company.name}}',
  'company.suffixes': '{{$company.name}}',
  'company.name': '{{$company.name}}',
  'database.collation': '{{$database.collation}}',
  'database.column': '{{$database.column}}',
  'database.engine': '{{$database.engine}}',
  'database.mongodbObjectId': '{{$database.mongodbObjectId}}',
  'database.type': '{{$database.type}}',
  'datatype.bigInt': '{{$number.bigInt}}',
  'datatype.boolean': '{{$datatype.boolean}}',
  'datatype.datetime': '{{$date.between}}',
  'datatype.float': '{{$number.float}}',
  'datatype.hexadecimal': '{{$string.hexadecimal}}',
  'datatype.number': '{{$number.int}}',
  'datatype.string': '{{$string.sample}}',
  'datatype.uuid': '{{$string.uuid}}',
  'date.between': '{{$date.between}}',
  'date.betweens': '{{$date.betweens}}',
  'date.birthdate': '{{$date.birthdate}}',
  'date.future': '{{$date.future}}',
  'date.month': '{{$date.month}}',
  'date.past': '{{$date.past}}',
  'date.recent': '{{$date.recent}}',
  'date.soon': '{{$date.soon}}',
  'date.weekday': '{{$date.weekday}}',
  'finance.account': '{{$finance.accountNumber}}',
  'finance.accountName': '{{$finance.accountName}}',
  'finance.amount': '{{$finance.amount}}',
  'finance.bic': '{{$finance.bic}}',
  'finance.bitcoinAddress': '{{$finance.bitcoinAddress}}',
  'finance.creditCardCVV': '{{$finance.creditCardCVV}}',
  'finance.creditCardIssuer': '{{$finance.creditCardIssuer}}',
  'finance.creditCardNumber': '{{$finance.creditCardNumber}}',
  'finance.currencyCode': '{{$finance.currencyCode}}',
  'finance.currencyName': '{{$finance.currencyName}}',
  'finance.currencySymbol': '{{$finance.currencySymbol}}',
  'finance.ethereumAddress': '{{$finance.ethereumAddress}}',
  'finance.iban': '{{$finance.iban}}',
  'finance.litecoinAddress': '{{$finance.litecoinAddress}}',
  'finance.mask': '{{$finance.maskedNumber}}',
  'finance.pin': '{{$finance.pin}}',
  'finance.routingNumber': '{{$finance.routingNumber}}',
  'finance.transactionDescription': '{{$finance.transactionDescription}}',
  'finance.transactionType': '{{$finance.transactionType}}',
  'git.branch': '{{$git.branch}}',
  'git.commitEntry': '{{$git.commitEntry}}',
  'git.commitMessage': '{{$git.commitMessage}}',
  'git.commitSha': '{{$git.commitSha}}',
  'git.shortSha': '{{$git.commitSha(length=7)}}',
  'hacker.abbreviation': '{{$hacker.abbreviation}}',
  'hacker.adjective': '{{$hacker.adjective}}',
  'hacker.ingverb': '{{$hacker.ingverb}}',
  'hacker.noun': '{{$hacker.noun}}',
  'hacker.phrase': '{{$hacker.phrase}}',
  'hacker.verb': '{{$hacker.verb}}',
  'helpers.replaceCreditCardSymbols': '{{$helpers.replaceCreditCardSymbols}}',
  'image.abstract': "{{$image.urlLoremFlickr(category='abstract')}}",
  'image.animals': "{{$image.urlLoremFlickr(category='animals')}}",
  'image.avatar': '{{$image.avatar}}',
  'image.business': "{{$image.urlLoremFlickr(category='business')}}",
  'image.cats': "{{$image.urlLoremFlickr(category='cats')}}",
  'image.city': "{{$image.urlLoremFlickr(category='city')}}",
  'image.dataUri': '{{$image.dataUri}}',
  'image.fashion': "{{$image.urlLoremFlickr(category='fashion')}}",
  'image.food': "{{$image.urlLoremFlickr(category='food')}}",
  'image.image': '{{$image.url}}',
  'image.imageUrl': '{{$image.url}}',
  'image.nature': "{{$image.urlLoremFlickr(category='nature')}}",
  'image.nightlife': "{{$image.urlLoremFlickr(category='nightlife')}}",
  'image.people': "{{$image.urlLoremFlickr(category='people')}}",
  'image.sports': "{{$image.urlLoremFlickr(category='sports')}}",
  'image.technics': "{{$image.urlLoremFlickr(category='technics')}}",
  'image.transport': "{{$image.urlLoremFlickr(category='transport')}}",
  'internet.avatar': '{{$image.avatarLegacy}}',
  'internet.color': '{{$internet.color}}',
  'internet.domainName': '{{$internet.domainName}}',
  'internet.domainSuffix': '{{$internet.domainSuffix}}',
  'internet.domainWord': '{{$internet.domainWord}}',
  'internet.email': '{{$internet.email}}',
  'internet.emoji': '{{$internet.emoji}}',
  'internet.exampleEmail': '{{$internet.exampleEmail}}',
  'internet.httpMethod': '{{$internet.httpMethod}}',
  'internet.httpStatusCode': '{{$internet.httpStatusCode}}',
  'internet.ip': '{{$internet.ip}}',
  'internet.ipv4': '{{$internet.ipv4}}',
  'internet.ipv6': '{{$internet.ipv6}}',
  'internet.mac': '{{$internet.mac}}',
  'internet.password': '{{$internet.password}}',
  'internet.port': '{{$internet.port}}',
  'internet.protocol': '{{$internet.protocol}}',
  'internet.url': '{{$internet.url}}',
  'internet.userAgent': '{{$internet.userAgent}}',
  'internet.userName': '{{$internet.userName}}',
  'lorem.lines': '{{$lorem.lines}}',
  'lorem.paragraph': '{{$lorem.paragraph}}',
  'lorem.paragraphs': '{{$lorem.paragraphs}}',
  'lorem.sentence': '{{$lorem.sentence}}',
  'lorem.sentences': '{{$lorem.sentences}}',
  'lorem.slug': '{{$lorem.slug}}',
  'lorem.text': '{{$lorem.text}}',
  'lorem.word': '{{$lorem.word}}',
  'lorem.words': '{{$lorem.words}}',
  'music.genre': '{{$music.genre}}',
  'music.songName': '{{$music.songName}}',
  'name.firstName': '{{$person.firstName}}',
  'name.fullName': '{{$person.fullName}}',
  'name.gender': '{{$person.gender}}',
  'name.jobArea': '{{$person.jobArea}}',
  'name.jobDescriptor': '{{$person.jobDescriptor}}',
  'name.jobTitle': '{{$person.jobTitle}}',
  'name.jobType': '{{$person.jobType}}',
  'name.lastName': '{{$person.lastName}}',
  'name.middleName': '{{$person.middleName}}',
  'name.prefix': '{{$person.prefix}}',
  'name.suffix': '{{$person.suffix}}',
  'phone.imei': '{{$phone.imei}}',
  'phone.number': '{{$phone.number}}',
  'random.alpha': '{{$string.alpha}}',
  'random.alphaNumeric': '{{$string.alphanumeric}}',
  'random.locale': '{{$string.fromCharacters}}',
  'random.numeric': '{{$string.numeric}}',
  'random.word': '{{$lorem.word}}',
  'random.words': '{{$lorem.words}}',
  'science.chemicalElement': '{{$science.chemicalElement}}',
  'science.unit': '{{$science.unit}}',
  'system.commonFileExt': '{{$system.commonFileExt}}',
  'system.commonFileName': '{{$system.commonFileName}}',
  'system.commonFileType': '{{$system.commonFileType}}',
  'system.directoryPath': '{{$system.directoryPath}}',
  'system.fileExt': '{{$system.fileExt}}',
  'system.fileName': '{{$system.fileName}}',
  'system.filePath': '{{$system.filePath}}',
  'system.fileType': '{{$system.fileType}}',
  'system.mimeType': '{{$system.mimeType}}',
  'system.networkInterface': '{{$system.networkInterface}}',
  'system.semver': '{{$system.semver}}',
  'vehicle.bicycle': '{{$vehicle.bicycle}}',
  'vehicle.color': '{{$vehicle.color}}',
  'vehicle.fuel': '{{$vehicle.fuel}}',
  'vehicle.manufacturer': '{{$vehicle.manufacturer}}',
  'vehicle.model': '{{$vehicle.model}}',
  'vehicle.type': '{{$vehicle.type}}',
  'vehicle.vin': '{{$vehicle.vin}}',
  'vehicle.Vrm': '{{$vehicle.vrm}}',
  'word.adjective': '{{$word.adjective}}',
  'word.adverb': '{{$word.adverb}}',
  'word.conjunction': '{{$word.conjunction}}',
  'word.interjection': '{{$word.interjection}}',
  'word.noun': '{{$word.noun}}',
  'word.preposition': '{{$word.preposition}}',
  'word.verb': '{{$word.verb}}'
};
function fakerUpgrade(oldStr) {
  var _map$oldStr;
  return (_map$oldStr = map[oldStr]) !== null && _map$oldStr !== void 0 ? _map$oldStr : oldStr;
}
exports.fakerUpgrade = fakerUpgrade;
